import {
    conjoin_with_previously_low_level_discarded_string,
    on_recog_msg_too_short,
    value_specific_rules,
    indexInSafe,
    get_latest_conjoined
} from "./recog_util";
import {
    getGroundingDataSetV2,
    conv_collect_replacements,
    msgObjectReplacements,
    parseConvoTimestampHires,
    getRandomSymbols,
    getConvoKeyTimestampHires,
    getNowStampAndTime,
    getPendingMsgDiff,
    fillFinalMsgIfEmpty,
    checkCallerDataHasExpectedResponseType,
    getCallerPrefilterInputCtx,
    fuzzDownBeatDown,
    fuzzMatchAgainstStringList,
    reinitTrimGlobals,
    handleOneFilterMatch,
    addRecogPhrasesOneTrim,
    handleMidFilterMatches,
    filterResultsProcessing,
    emptyPositiveAiResult,
    runAiValCheck,
    resetTrimmedCollectionFlags,
    runAiMatching,
    resetConjoinedConditionalV2
} from "./../SpeechRecognizer/process_v2";

import { removeEnclosingQuotes, getAlphaNumeric, getOnlyNumeric, getLettersOnly, newConvoStamp, fuzzMtch, bestWildcardMatch } from "../../util_glob";
import { qRamJet, qAiTopicChangeV2 } from "./../../api";
import { gselectedgroup, RecognizedProcessObj } from "../../interfaces";
import { ConnectionState } from "../../types/connection-state";

export type KgnfRespondCCA = (fin: any, exp_resp_type: string, callerName: string) => void;

export interface ProcessRecognizedV2Args {
    eResultText: string;
    eResultLanguage: string;
    selectedGroup: gselectedgroup;
    kgnf_respond_cca: KgnfRespondCCA;
    force_through?: boolean;
    stream_sid?: string;
    main_state?: Record<string, any>;
    ignore_discard?: boolean;
}

let PHONE_NUMBER_UI_CONFIG_NAME = "User_Id";

function callerNameToInt(main_state: any, stream_sid: string) {
    let callerName = window.cca["CallerName"];
    if (callerName && typeof callerName === "string" && callerName !== "") {
        try {
            //callerName = parseInt(callerName, 10);
            callerName = callerName;
        } catch (e) {
            console.log("errr caller_name_int_convert_01");
        }
    }
    return callerName;
}

function valueSpecificRules(expRespType: string, conjoinedObj: any) {
    let specificRulesPass = false;
    if (expRespType === "") return true;

    const uiNumberConfigName = PHONE_NUMBER_UI_CONFIG_NAME.toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");
    const keylet = expRespType
        .toLowerCase()
        .trim()
        .replace(/[^A-Za-zА-Яа-я]/g, "");
    const conjoinedSegments = (conjoinedObj["conjoined_segments"] || "").toLowerCase().trim();
    const msgNumeric = getOnlyNumeric(conjoinedSegments);
    const lastCharMatch = conjoinedSegments.match(/[A-Za-zА-Яа-я0-9]/g);
    const lastChar = lastCharMatch ? lastCharMatch.slice(-1)[0] : "";

    if (keylet.includes("carregistration")) {
        // Last char must be a letter (Latin or Cyrillic) and length > 3
        if (msgNumeric.length > 3) {
            specificRulesPass = true;
        }
    } else if (keylet.includes(uiNumberConfigName)) {
        // Must be more than 4 digits
        if (msgNumeric.length > 4) {
            specificRulesPass = true;
        }
    } else {
        // No specific rule
        specificRulesPass = true;
    }
    return specificRulesPass;
}

function getRecognizedProcessObj(): RecognizedProcessObj {
    return {
        final_upstream_msg: "",
        should_run_oai: false,
        conjoined_obj: { conjoined_msg: "", conjoined_segments: "" },
        conj_clean: "",
        value_valid_bot_not_in_data: "",
        additional_instructions: "",
        msg_ovrride: ""
    };
}
const log_stamp = () => Date.now();

function parseRamAiResponse(ram: any, mainState: any, streamSid: string) {
    if (ram && ram.reply) {
        if (ram.reply.length > 0) {
            const idAnswer = ram.reply[0];
            if (idAnswer === 3) {
                console.log("🔥⃤ 🕔 WAIT ⇐ ram_jet_action", ram.reply);
                return true;
            } else if (idAnswer === 2) {
                console.log("🔥⃤ 🗑️ DISCARD ⇐ ram_jet_action", ram.reply);
                resetConjoinedConditionalV2();
                return false;
            } else if (idAnswer === 1) {
                console.log("🔥⃤ 👊 ANSWER ⇐ ram_jet_action", ram.reply);
                return false;
            }
        }
    }
    return false;
}

export async function processRecognizedV2({
    eResultText,
    eResultLanguage,
    selectedGroup,
    kgnf_respond_cca,
    force_through = false,
    stream_sid = "",
    main_state = {},
    ignore_discard = false
}: ProcessRecognizedV2Args) {
    const fileList = window.globalFL;
    const x_conf = window.cca?.docextractionconfig ?? [];
    const caller_prefilter = window.cca?.caller_match ?? [];

    let fin = getRecognizedProcessObj();

    try {
        // 1️⃣  expected response type & conjoin
        const exp_resp_type = window.cca?.conversation_state?.global_expected_next_user_response_type ?? "";
        fin.conjoined_obj = conjoin_with_previously_low_level_discarded_string(eResultText);

        const rs = window.cca?.conversation_state?.global_convo_last_response_start ?? 0;
        const rf = window.cca?.conversation_state?.global_convo_last_response_finish ?? 0;
        if (rs > rf) {
            console.log("🎡", exp_resp_type, eResultText);
            const ram = await qRamJet(window.cca, stream_sid, exp_resp_type, fin, selectedGroup);
            const should_stop = parseRamAiResponse(ram, window.cca, stream_sid);
            if (should_stop) return;
        }

        console.log("⚔️ 0000", log_stamp(), fin.conjoined_obj);
        if (on_recog_msg_too_short(fin.conjoined_obj.conjoined_msg)) {
            console.log("🩳 0000_msg", fin.conjoined_obj.conjoined_msg);
            return;
        }

        let uniq_strings: any[] = [];
        let match_down = [];
        const callerName = callerNameToInt(window.cca, stream_sid);
        if (x_conf && x_conf.length > 0) {
            console.log("📞 0001_res", exp_resp_type);

            // 2.1  contextual data for grounding
            const confFieldNames = x_conf.map((item: any) => item.name);
            const dataOptions = getGroundingDataSetV2(exp_resp_type, x_conf, fileList);
            const conf_details = dataOptions.conf ?? {};

            // @ts-ignore
            const conf_type = conf_details?.type ? conf_details.type : "";

            if (dataOptions.values && dataOptions.shouldGo === true) {
                const keyname = dataOptions.keyname;
                msgObjectReplacements(fin, conv_collect_replacements);
                if (conf_type === "number") fin.conjoined_obj.conjoined_segments = fin.conjoined_obj.conjoined_segments.replace(/но/g, "0");

                fin.final_upstream_msg = fin.conjoined_obj.conjoined_segments;

                console.log("💬‾0002¦🐺 ", exp_resp_type, "¦", fin.conjoined_obj.conjoined_segments, " ¦ ", fin.conjoined_obj.conjoined_msg);

                if (keyname && dataOptions.values.length > 0) {
                    console.log("📄‾0002_9_data_available");
                    const msg_numeric = getOnlyNumeric(fin.conjoined_obj.conjoined_segments);

                    if (!valueSpecificRules(exp_resp_type, fin.conjoined_obj)) {
                        console.log("❌ valueSpecRules‾not‾met, skipping processing");
                        if (!force_through) {
                            runSilenceCheck(window.cca, stream_sid, selectedGroup, conf_details, 3, 4, "👀 S1");
                            return;
                        }
                    } else console.log("✅ valueSpecRules‾are‾met");

                    // 2.2  caller‑specific data pre‑filter
                    const expectedFieldInCallerData = checkCallerDataHasExpectedResponseType(caller_prefilter, exp_resp_type);
                    let uniq_candidate = [];
                    let uniq_strings: any[] = [];
                    let sgmMsg = fin["conjoined_obj"]["conjoined_segments"];

                    if (expectedFieldInCallerData?.length) {
                        console.log("🔗 0003_caller_prop_match", exp_resp_type, expectedFieldInCallerData);
                        const callerDataOptions = getCallerPrefilterInputCtx(
                            caller_prefilter,
                            exp_resp_type,
                            conf_details,
                            dataOptions.all_related_configs ?? {},
                            dataOptions.joinkeys ?? []
                        );
                        match_down = fuzzDownBeatDown(
                            callerDataOptions,
                            exp_resp_type,
                            String(fin.conjoined_obj.conjoined_segments),
                            window.cca?.conversation_state
                        );
                        uniq_strings = [...new Set(match_down.map((i: any) => i[exp_resp_type]))];
                    }

                    // 2.3  trimmed‑value‑collection flow (two‑step)
                    if (window.cca?.is_trimmed_value_collection === true && window.cca?.trimmed_step_int === 0) {
                        console.log("📄‾0002_9_is_trimmed_value_collect", sgmMsg);

                        if (window.cca?.trimmed_data_set && window.cca?.trimmed_data_set.length > 0) {
                            const trimmedPhraseList = window.cca?.trimmed_phrase_list ?? [];
                            const trimmedDataSet = window.cca?.trimmed_data_set;
                            const maxTrimmerLengthOg = window.cca?.max_trimmer_length || 0;

                            console.log(`📏 trimmed_data_set‾over‾0: ${trimmedDataSet.length}`);
                            const sgmAn = getAlphaNumeric(sgmMsg);
                            if (String(sgmAn).length - 1 === maxTrimmerLengthOg) {
                                let match = fuzzMatchAgainstStringList(sgmMsg, trimmedPhraseList, exp_resp_type);

                                console.log(`🥅 fuzz_match: ${match}`);
                                if (match) {
                                    match = getAlphaNumeric(match);
                                    const filteredDataSet = trimmedDataSet.filter(
                                        (item: any) => String(item[exp_resp_type] ?? "").slice(0, maxTrimmerLengthOg) === match
                                    );
                                    console.log(`🗂️ filtered_data_set: ${filteredDataSet.length}`);

                                    const filtStrSet = new Set(filteredDataSet.map((item: any) => String(item["exp_resp_type"])));

                                    if (filtStrSet.size === 1) {
                                        console.log(`⚖️ filtered_current_strgs‾eq_1`, filteredDataSet);
                                        reinitTrimGlobals(window.cca, stream_sid);
                                        fin = handleOneFilterMatch(filteredDataSet, fin, exp_resp_type);
                                    } else if (filtStrSet.size > 1) {
                                        const filteredCurrentStrgs = filteredDataSet.map((item: any) =>
                                            String(item["exp_resp_type"]).slice(maxTrimmerLengthOg)
                                        );
                                        console.log(`☝️ filtered_current_strgs‾over_1`, filteredCurrentStrgs.length);

                                        const [isTrimmed, maxTrimmerLength, phraseList] = addRecogPhrasesOneTrim(window.cca.transcriber, filteredCurrentStrgs);

                                        window.cca.is_trimmed_value_collection = isTrimmed;
                                        window.cca.max_trimmer_length = maxTrimmerLengthOg; // preserve original
                                        window.cca.trimmed_phrase_list = phraseList;
                                        window.cca.trimmed_data_set = filteredDataSet;
                                        window.cca.trimmed_step_int += 1;

                                        return;
                                    }
                                }
                            } else {
                                console.log("📏 trimmed_data_set‾not‾eq", String(sgmMsg).length - 1, maxTrimmerLengthOg, sgmAn);
                                reinitTrimGlobals(window.cca, stream_sid);
                            }
                        }
                    } else if (window.cca?.is_trimmed_value_collection === true && (window.cca?.trimmed_step_int ?? 0) > 0) {
                        console.log("📄‾0002_10_is_trimmed_step", window.cca?.trimmed_step_int);

                        const trimmedPhraseList = window.cca?.trimmed_phrase_list ?? [];
                        const trimmedDataSet = window.cca?.trimmed_data_set ?? [];
                        const maxTrimmerLength = window.cca?.max_trimmer_length || 0;

                        console.log("📄 trimmed_data_set", maxTrimmerLength, trimmedDataSet);
                        let match = fuzzMatchAgainstStringList(sgmMsg, trimmedPhraseList, exp_resp_type);
                        match = getAlphaNumeric(match ?? "");

                        const filteredDataSet = trimmedDataSet.filter((item: any) => String(item[exp_resp_type] ?? "").slice(maxTrimmerLength) === match);

                        const filtStrSet = new Set(filteredDataSet.map((item: any) => String(item["exp_resp_type"])));

                        if (filtStrSet.size === 1) {
                            reinitTrimGlobals(window.cca, stream_sid);
                            fin = handleOneFilterMatch(filteredDataSet, fin, exp_resp_type);
                        } else if (filtStrSet.size > 1 && filtStrSet.size <= 20) {
                            reinitTrimGlobals(window.cca, stream_sid);
                            fin = handleMidFilterMatches(filteredDataSet, fin, exp_resp_type);
                        }
                    }

                    // 2.4  generic fuzzy if not already matched
                    if (uniq_strings.length === 0) {
                        match_down = fuzzDownBeatDown(dataOptions, exp_resp_type, String(fin.conjoined_obj.conjoined_segments), window.cca?.conversation_state);
                        uniq_strings = [...new Set(match_down.map((i: any) => i[exp_resp_type]))];
                    }

                    console.log(
                        "📍 0003¦now¦",
                        log_stamp(),
                        "¦msg¦",
                        fin.conjoined_obj.conjoined_segments,
                        "¦type¦",
                        exp_resp_type,
                        "¦found¦",
                        uniq_strings.length
                    );

                    // 2.5  result management mirroring python control‑flow
                    const valueRulesMet = valueSpecificRules(exp_resp_type, fin.conjoined_obj) === true;
                    const numericLen = msg_numeric.length;
                    if (
                        (valueRulesMet && uniq_strings.length && uniq_strings.length < 20) ||
                        (numericLen > 1 && uniq_strings.length && uniq_strings.length < 20)
                    ) {
                        console.log("▩‾0004_1", exp_resp_type, uniq_strings);
                        if (uniq_strings.length === 1) {
                            fin = await handleOneFilterMatch(uniq_strings, fin, exp_resp_type);
                        } else if (uniq_strings.length < 20) {
                            fin = await handleMidFilterMatches(uniq_strings, fin, exp_resp_type);
                            fin.should_run_oai = true;
                        } else if (confFieldNames.includes(exp_resp_type)) {
                            fin.conjoined_obj = get_latest_conjoined();
                            const ai_value_extract = await runAiTopicChange(
                                window.cca,
                                stream_sid,
                                fin.conjoined_obj.conjoined_segments,
                                conf_details,
                                selectedGroup
                            );
                            if (ai_value_extract.user_asks_or_requests) {
                                // user interruption – do nothing extra
                            } else if (ai_value_extract.requested_value && ai_value_extract.value_ok) {
                                const match_down_re = fuzzDownBeatDown(
                                    dataOptions,
                                    exp_resp_type,
                                    String(ai_value_extract.requested_value),
                                    window.cca.conversation_state
                                );
                                uniq_strings = [...new Set(match_down_re.map((i: any) => i[exp_resp_type]))];
                                if (uniq_strings.length) {
                                    const res = await filterResultsProcessing(window.cca, uniq_strings, ai_value_extract, exp_resp_type, fin);
                                    fin = res.fin;
                                    if (res.halt && !force_through) {
                                        runSilenceCheck(window.cca, stream_sid, selectedGroup, conf_details, 3, 4, "👀 S2");
                                        return;
                                    }
                                }
                            } else if (!force_through) {
                                runSilenceCheck(window.cca, stream_sid, selectedGroup, conf_details, 3, 4, "👀 S3");
                                return;
                            }
                        }
                    } else if (confFieldNames.includes(exp_resp_type)) {
                        let ai_value_extract = emptyPositiveAiResult();
                        if (fin.conjoined_obj.conjoined_segments.length > 1) {
                            ai_value_extract = await runAiValCheck(
                                window.cca,
                                stream_sid,
                                exp_resp_type,
                                fin.conjoined_obj.conjoined_segments,
                                conf_details,
                                selectedGroup
                            );
                        }
                        if (!ai_value_extract.user_asks_or_requests && !ai_value_extract.is_different_direction && !force_through) {
                            runSilenceCheck(window.cca, stream_sid, selectedGroup, conf_details, 3, 4, "👀 S4");
                            return;
                        }
                    }
                } else {
                    fin.final_upstream_msg = fin.conjoined_obj.conjoined_msg;
                }
            } else {
                fin.final_upstream_msg = fin.conjoined_obj.conjoined_msg;
            }

            // 2.6  optional AI refinement
            if (uniq_strings.length && fin.should_run_oai) {
                let enhanced = fin.conjoined_obj.conjoined_segments;
                if (fin.additional_instructions) enhanced += ` ${fin.additional_instructions}`;
                const res = await runAiMatching(window.cca, stream_sid, fin, uniq_strings, conf_details);
                if (res?.matching_value) fin.additional_instructions = `Correct ${exp_resp_type}: ${res.matching_value}`;
            } else if (uniq_strings.length === 1) {
                fin.additional_instructions = `Correct ${exp_resp_type}: ${uniq_strings[0]}`;
            } else if (uniq_strings.length > 1 && uniq_strings.length < 5) {
                fin.additional_instructions = `Correct value options for ${exp_resp_type}: ${uniq_strings.slice(0, 5).join(", ")}`;
            }

            fin.final_upstream_msg = fillFinalMsgIfEmpty(fin.final_upstream_msg, fin.conjoined_obj);

            // 2.7  compose enhanced message for backend
            let fin_msg_enhanced = "";
            if (fin.value_valid_bot_not_in_data && fin.additional_instructions) {
                fin_msg_enhanced = `${fin.additional_instructions}¦${fin.value_valid_bot_not_in_data}`;
            } else if (fin.value_valid_bot_not_in_data) {
                fin_msg_enhanced = `¦${fin.value_valid_bot_not_in_data}`;
            } else {
                fin_msg_enhanced = `${fin.additional_instructions}¦`;
            }

            console.log(fin_msg_enhanced ? "🔀 32" : "▩ 33", fin.final_upstream_msg);

            window.cca = resetTrimmedCollectionFlags(window.cca, stream_sid);
            window.cca.pending_sentence = fin.conjoined_obj.conjoined_segments;
            resetConjoinedConditionalV2();
            await kgnf_respond_cca(fin, exp_resp_type, callerName || "");

            return;
        }

        console.log("🛫 3️⃣ len_uniq_str ⇒ ", uniq_strings.length, " 🐺 ", exp_resp_type);
        window.cca.uniq_strings = uniq_strings;
        window.cca.pending_sentence = fin.conjoined_obj.conjoined_segments;
        resetConjoinedConditionalV2();
        await kgnf_respond_cca(fin, exp_resp_type, callerName || "");

        return;
    } catch (err) {
        console.error("errr_rcgnzd", err);
    }
}

async function runAiTopicChange(mainState: any, streamSid: string, ongoingMsg: string, confDetails: any, selectedGroup: gselectedgroup, choices = null) {
    const start = performance.now();

    const response = await qAiTopicChangeV2(
        ongoingMsg,
        mainState[streamSid]["last_message"],
        mainState[streamSid]["conversation_state"]["global_expected_next_user_response_type"],
        mainState[streamSid]["conversation_state"]["global_simple_convo_list"],
        confDetails,
        selectedGroup,
        streamSid,
        choices,
        "gpt-4.1-nano"
    );

    console.log("⏱️👾 topic_chng_perf", (performance.now() - start) / 1000);

    if (response) {
        return {
            value_ok: indexInSafe(response, "value_ok", false),
            requested_value: indexInSafe(response, "requested_value", ""),
            is_different_direction: indexInSafe(response, "is_different_direction", false),
            user_asks_or_requests: indexInSafe(response, "user_asks_or_requests", false)
        };
    } else {
        return {};
    }
}

async function runSilenceCheck(
    mainState: any,
    streamSid: string,
    selectedGroup: gselectedgroup,
    confDetails: any,
    speechThresh: number,
    recogThresh: number,
    src: string,
    kgnf_respond_cca: any = null
) {
    await silenceCheck({
        streamSid,
        selectedGroup,
        counter: 0,
        stamp: 0,
        imp: false,
        interrupt: false,
        tOut: 1000,
        speechThresh,
        recogThresh,
        src,
        runid: "",
        mainState,
        confDetails,
        kgnf_respond_cca
    });
}

export interface SilenceCheckArgs {
    streamSid: string;
    selectedGroup: gselectedgroup;
    counter?: number;
    stamp?: number;
    imp?: boolean;
    interrupt?: boolean;
    tOut?: number;
    speechThresh?: number;
    recogThresh?: number;
    src?: string;
    runid?: string;
    mainState?: any;
    confDetails?: any;
    kgnf_respond_cca: KgnfRespondCCA;
}

async function silenceCheck({
    streamSid,
    selectedGroup,
    counter = 0,
    stamp = 0,
    imp = false,
    interrupt = false,
    tOut = 1000,
    speechThresh = 4,
    recogThresh = 5,
    src = "src",
    runid = "",
    confDetails = {},
    kgnf_respond_cca
}: SilenceCheckArgs) {
    try {
        if (!window.cca) window.cca = {} as ConnectionState;
        if (!window.cca.conversation_state) window.cca.conversation_state = {} as ConversationState;
        if (!window.cca || (interrupt !== true && window.cca.conversation_state?.global_is_tracking_silence === true)) return;

        window.cca.conversation_state.global_is_tracking_silence = true;

        if (!runid) runid = getRandomSymbols();
        if (stamp === 0) stamp = getConvoKeyTimestampHires();
        const stampParse = parseConvoTimestampHires(stamp);

        const { nowPre, now } = getNowStampAndTime();

        window.cca.conversation_state.global_convo_last_response_start ??= nowPre;
        window.cca.conversation_state.global_convo_last_response_finish ??= nowPre;
        window.cca.conversation_state.global_convo_last_speech_start ??= nowPre;
        window.cca.conversation_state.global_convo_last_speech_finish ??= nowPre;
        window.cca.conversation_state.global_convo_last_user_fininsh ??= nowPre;

        while (true) {
            await new Promise(res => setTimeout(res, tOut));

            const { nowPre, now } = getNowStampAndTime();
            const pendingDiff = getPendingMsgDiff(window.cca, streamSid);

            const sinceLastRecoging = (now.getTime() - parseConvoTimestampHires(window.cca.conversation_state.globalConvPerfRecog ?? nowPre).getTime()) / 1000;
            const sinceLastRecoged = (now.getTime() - parseConvoTimestampHires(window.cca.conversation_state.convoPerfOnRecogFin ?? nowPre).getTime()) / 1000;
            const sinceAiLastSpeechFinish =
                (now.getTime() - parseConvoTimestampHires(window.cca.conversation_state.global_convo_last_speech_finish ?? nowPre).getTime()) / 1000;
            const sinceAiLastSpeechStart =
                (now.getTime() - parseConvoTimestampHires(window.cca.conversation_state.global_convo_last_speech_start ?? nowPre).getTime()) / 1000;

            const speechStart = parseConvoTimestampHires(window.cca.conversation_state.global_convo_last_speech_start ?? now);

            console.log("👀 👾▶️", sinceAiLastSpeechStart, "👾🏁", sinceAiLastSpeechFinish, "👤▶️", sinceLastRecoging, "💬", pendingDiff);

            if (speechStart > stampParse) {
                window.cca.conversation_state.global_is_tracking_silence = false;
                console.log("👀🚧 speech_start > stamp", stampParse);
                break;
            }

            if (sinceAiLastSpeechFinish > speechThresh && sinceLastRecoging > recogThresh && pendingDiff < 5) {
                if (sinceAiLastSpeechStart < sinceAiLastSpeechFinish || sinceLastRecoging < 3) {
                    // do nothing, wait
                } else {
                    const recogFin = window.cca.conversation_state.global_convo_cadance_stamp ?? 0;
                    const segments = window.cca.conversation_state.global_run_on_sentence?.segments || [];
                    const ongoingMsg = segments
                        .filter((item: any) => item.cadancestamp === recogFin)
                        .map((item: any) => item.msg)
                        .join(" ");

                    const aiValueExtract = await runAiTopicChange(window.cca, streamSid, ongoingMsg, confDetails, selectedGroup);
                    console.log("👀 ai", aiValueExtract);

                    if (indexInSafe(aiValueExtract, "is_different_direction", true) || indexInSafe(aiValueExtract, "user_asks_or_requests", true)) {
                        console.log("👀 ai rerun");
                        window.cca.conversation_state.global_is_tracking_silence = false;
                        if (!window.cca.conversation_state.global_convo_rollon_recognizing) window.cca.conversation_state.global_convo_rollon_recognizing = [];
                        window.cca.conversation_state.global_convo_rollon_recognizing.push("[Кратко мълчание...]");

                        await processRecognizedV2({
                            eResultText: "[Кратко мълчание...]",
                            eResultLanguage: window.cca.lang || "en",
                            selectedGroup: selectedGroup,
                            force_through: false,
                            stream_sid: streamSid,
                            main_state: window.cca,
                            ignore_discard: false,
                            kgnf_respond_cca: kgnf_respond_cca
                        });
                        break;
                    }
                }
            }
        }
    } catch (err) {
        console.error("errr_gen_001", err);
    }
}
